import { Guide } from './guideTypes';
import { facilityAssessmentGuide } from './facilityAssessmentGuide';
import { buildingAssistantGuide } from './buildingAssistantGuide';

/* The registry of user guides. Add a module’s guide here and it appears in the Help page’s guide
   list automatically; the first entry is the default. */
export const GUIDES: Guide[] = [
  facilityAssessmentGuide,
  buildingAssistantGuide,
];

export const getGuide = (id: string): Guide | undefined => GUIDES.find(g => g.id === id);
